import MDEditor from "@uiw/react-md-editor"
import { Controller, } from "react-hook-form"
import React from "react"
import { FormControl, FormLabel, } from "@fedsim/components"
import FormError from "./error"

export const FormMarkdown = ({ name, control, label, }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, }, fieldState: { errors, }, }) => (
        <FormControl fullWidth>
        {errors?.[name]?.type && <FormError type={errors?.[name]?.type} />}
          <FormLabel htmlFor="image">{label}</FormLabel>
            <MDEditor value={value} onChange={onChange} />
        </FormControl>
      )}
    />
  )
}

export default FormMarkdown
